export const CREATE_REQUEST_CUSTOM_FIELD = 'CREATE_REQUEST_CUSTOM_FIELD'
export const UPDATE_REQUEST_CUSTOM_FIELD = 'UPDATE_REQUEST_CUSTOM_FIELD'
export const DELETE_REQUEST_CUSTOM_FIELD = 'DELETE_REQUEST_CUSTOM_FIELD'